import { render } from "./InquiryExperiments.vue?vue&type=template&id=232f57cd&scoped=true"
import script from "./InquiryExperiments.vue?vue&type=script&lang=js"
export * from "./InquiryExperiments.vue?vue&type=script&lang=js"

import "./InquiryExperiments.vue?vue&type=style&index=0&id=232f57cd&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232f57cd"]])

export default __exports__